export default {"src":"/_next/static/media/cat-takaful-plan.a570af86.svg","height":48,"width":48};